export default {
  inserted: function (el, binding, vNode) {
    const ELEMENT = el.tagName
    if (ELEMENT === 'FORM' || ELEMENT === 'DIV') {
      const elementsArray = [...el.getElementsByTagName('input'), ...el.getElementsByTagName('button')]
      if (elementsArray.length) {
        for (let i = 0; i < elementsArray.length; i++) {
          if ((elementsArray[i].tagName === 'INPUT' || elementsArray[i].tagName === 'BUTTON') && elementsArray[i].type !== 'hidden') {
            elementsArray[i].focus()
            break
          }
        }
      }
    }

    if (ELEMENT === 'INPUT' || ELEMENT === 'BUTTON') {
      el.focus()
    }
  }
}
